import styled, { css, keyframes } from 'styled-components';
import { IInputTextAreaWrapperStyleProps } from './interfaces';

const saving = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
`;

export const InputTextAreaWrapper = styled.div<IInputTextAreaWrapperStyleProps>`
/* stylelint-disable */
textarea {
    display: block;
}
/* stylelint-enable */
${p =>
    p.isSaving &&
    css`
        animation: ${saving} infinite 0.8s;
        textarea {
            &:disabled {
                border: ${p => p.theme.c.disabled} 1px solid;
                color: ${p => p.theme.c.dark} !important;
                opacity: 1;
                font-weight: 300;
            }
        }
    `}
${p =>
    p.isCompleted &&
    css`
        textarea:disabled {
            background-color: #d9f8de;
            ${p => p.theme.mode === "dark" && css`
                color: ${p => p.theme.c.dark} !important;
            `}
        }
    `}
`;